export class settingsNavigation {
    
  static  allSettings: any[] = [
        {
            "id": "security",
            "title": "NXI_NAVIGATION.SECURITYSETTINGS",
            "description": "NXI_SETTINGS.securitysettings",
            "entitlements": "ANY",
            "url": "/nxi/settings/securitysettings",
            "isEntitled": false
        },
        {
            "id": "display",
            "title": "NXI_NAVIGATION.DISPLAYSETTINGS",
            "description": "NXI_SETTINGS.displaysettings",
            "entitlements": "DISPLAY_SETTINGS",
            "url": "/nxi/settings/displaysettings",
            "isEntitled": false

        },
        {
            "id": "edelpreferences",
            "title": "NXI_NAVIGATION.EDELPREFERENCES",
            "description": "NXI_SETTINGS.edelpreferences",
            "entitlements": "ELECTRONIC_NOTIFICATION",
            "url": "/nxi/settings/edelpreferences",
            "isEntitled": false
        },
        {
            "id": "notificationsetup",
            "title": "NXI_NAVIGATION.NOTIFICATIONSETUP",
            "description": "NXI_SETTINGS.notificationsetup",
            "entitlements": "ELECTRONIC_NOTIFICATION || ALERTS || ALERTS_TRADE || ALERTS_ACTIVITY || ALERTS_MARGIN || ALERTS_POSITIONS_SUMMARY || ASSET_TRANSFER_MASTER || DIGITAL_AUTHORIZATION",
            "url": "/nxi/settings/notificationsetup",
            "isEntitled": false
        }
    ];
}